import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Formik, Form } from 'formik';
import Button from '@material-ui/core/Button';
import * as Yup from 'yup';
import { Paper, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import { api } from '../../redux/services/api';
import GenericDialog from './GenericDialog';
import { getContentGrapesJSComponent, getColorHexUsingComputedStyle } from '../../utils';
import EbookSettings from '../EbookSettings';

const useStyles = makeStyles((theme) => ({
	boxContent: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.paper,

		'& .form-title': {
			marginBottom: '2rem',
		},
	},
	descriptionWrapper: {
		paddingBottom: theme.spacing(2),
	},
	eachComponent: {
		width: 300,
		marginBottom: theme.spacing(2.5),
		'& label': {
			marginBottom: theme.spacing(1),
			display: 'block',
		},
	},
	formWrapper: {
		'& .submitButton': {
			textAlign: 'right',
		},
	},
}));

const EditEbookSectionDialog = (props) => {
	const { open, handleClose } = props;
	const classes = useStyles();
	const ebook = useStoreState((state) => state.template.ebook);
	const loadTemplate = useStoreActions((actions) => actions.template.loadTemplate);

	const handleSave = async (values) => {
		console.log('EditEbookSectionDialog handleSave', values);
		// Save to DB
		const response = await api.post(
			`${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/save_sitesettings_details/`,
			{
				ebook: values.ebook,
			},
		);
		const responseStatus = response?.status;
		console.log('EditEbookSectionDialog handleSave responseStatus', responseStatus);
		await loadTemplate();

		handleClose && handleClose();
	};

	const renderForm = (formikBags) => {
		return (
			<Form className={classes.formWrapper}>
				<EbookSettings lightBackground {...props} {...formikBags} />
				<Box p={1} pt={2}>
					<div className="submitButton">
						<Button
							variant="contained"
							color="primary"
							type="submit"
							// onClick={handleSave}
						>
							{_e('save')}
						</Button>
					</div>
				</Box>
			</Form>
		);
	};

	const buttonLabel = getContentGrapesJSComponent('#section-ebook .ebook-download-button');
	const headerColorHex = getColorHexUsingComputedStyle('ebook', 'header');
	const textColorHex = getColorHexUsingComputedStyle('ebook', 'body');
	const buttonTextColorHex = getColorHexUsingComputedStyle('ebook', 'buttonTextColor', {
		defaultColorHex: '#ffffff',
	});
	const buttonBackgroundColorHex = getColorHexUsingComputedStyle(
		'ebook',
		'buttonBackgroundColor',
		{
			colorProperty: 'background-color',
		},
	);
	const popupTitle = getContentGrapesJSComponent('.ebook-modal .modal-card-title');
	const popupMessage = getContentGrapesJSComponent('.ebook-modal .popup-message');

	const ebookInitialValues = {
		...ebook,
		// headerColor: headerColorHex,
		// textColor: textColorHex,
		// buttonTextColor: buttonTextColorHex,
		// buttonBackgroundColor: buttonBackgroundColorHex
	};

	const renderContent = () => {
		return (
			<div className={`useImageBrowseWrapper`}>
				<Paper elevation={0} className={classes.boxContent}>
					<Formik
						initialValues={{
							ebook: ebookInitialValues,
							buttonLabel,
							headerColor: headerColorHex,
							textColor: textColorHex,
							buttonTextColor: buttonTextColorHex,
							buttonBackgroundColor: buttonBackgroundColorHex,
							popupTitle,
							popupMessage,
						}}
						validationSchema={Yup.object({
							// subdomain: Yup.string()
							//   .max(15, 'Must be 15 characters or less')
							//   .required('Required')
						})}
						onSubmit={async (values, { setSubmitting }) => {
							// showFormikValues(values, setSubmitting);
							await handleSave(values);
							setSubmitting(false);
						}}
					>
						{renderForm}
					</Formik>
				</Paper>
				<Box p={1} />
			</div>
		);
	};
	return (
		<GenericDialog
			shadedContent
			maxWidth="md"
			// fullWidth
			title={_e('ebook')}
			subtitle={_e('ebook_personal_branding')}
			content={renderContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditEbookSectionDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	sectionId: PropTypes.string,
};

export default EditEbookSectionDialog;
